import { CollectorMonthView } from "./CollectorMonthView";

export default CollectorMonthView;